import { render, staticRenderFns } from "./InspectOrderPage.vue?vue&type=template&id=b3aebbe6&scoped=true"
import script from "./InspectOrderPage.vue?vue&type=script&lang=js"
export * from "./InspectOrderPage.vue?vue&type=script&lang=js"
import style0 from "./InspectOrderPage.vue?vue&type=style&index=0&id=b3aebbe6&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3aebbe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3aebbe6')) {
      api.createRecord('b3aebbe6', component.options)
    } else {
      api.reload('b3aebbe6', component.options)
    }
    module.hot.accept("./InspectOrderPage.vue?vue&type=template&id=b3aebbe6&scoped=true", function () {
      api.rerender('b3aebbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/inspectOrder/inspectOrderPage/InspectOrderPage.vue"
export default component.exports